import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-circle",
  "use": "icon-circle-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-circle\"><path d=\"M512 0c282.7776 0 512 229.2224 512 512s-229.2224 512-512 512S0 794.7776 0 512 229.2224 0 512 0z m0 153.6a358.4 358.4 0 1 0 358.4 358.4h-76.8A281.6 281.6 0 1 1 512 230.4z m0 153.6a204.8 204.8 0 0 0-204.8 204.8h76.8a128 128 0 1 1 128 128V716.8a204.8 204.8 0 1 0 0-409.6z\" fill=\"#3D61E3\" p-id=\"5032\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol